import React from 'react'
import ListBrandsPage from "./ListBrandsPage";
import { canViewStoreName as checkStoreName } from '../../../services/StorageServices'

function ListBrandsContainer(props) {
    if (!checkStoreName()) {
        return <div className="text-center mt-5"><h4>You do not have permission to access this page.</h4></div>
    }

    return (
        <div className="SettingShippingRuleContainer">
            <ListBrandsPage/>
        </div>
    )
}

export default ListBrandsContainer